import React, { useState } from 'react'

import {
  Collapse,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons'


interface InstructionsProps {
  children: React.ReactNode
}

export const Instructions = (props: InstructionsProps) => {
  const { children } = props
  const [expanded, setExpanded] = useState(false)
  return (
    <Alert severity="info">
      <Grid container alignItems="center">
        <Grid item>
          <Typography variant="h6">Instructions</Typography>
        </Grid>
        <Grid item>
          <IconButton onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Grid>
      </Grid>
      <Collapse in={expanded}>
        {children}
      </Collapse>
    </Alert>
  )
}
